import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { orders as ordersAPI } from 'api';
import { getOrdersApiHOC } from '../selectors';
import { types } from './actions';

export const getIsFetching = state => getOrdersApiHOC(state).isFetching;

export const getOrderNumber = state => getOrdersApiHOC(state).orderNumber;

export default combineReducers({
  isFetching: handleActions({
    [ordersAPI.types.POST_ORDER_REQUEST]: () => true,
    [ordersAPI.types.POST_ORDER_SUCCESS]: () => false,
    [ordersAPI.types.POST_ORDER_FAILURE]: () => false,
  }, false),
  orderNumber: handleActions({
    [ordersAPI.types.POST_ORDER_SUCCESS]: (state, { payload: { orderNumber } }) => orderNumber,
    [types.ORDERS_API_HOC_RESET]: () => null,
  }, null),
});



// WEBPACK FOOTER //
// ./src/components/apiHOCs/OrdersApiHOC/reducers.js